module.exports = __webpack_public_path__ + "static/media/boarding.01e1c299.jpg";